import dayjs from 'dayjs';
import { TOKEN_SECRET } from '@mc/base';
import { aesEncode } from '@mc/encryption';
import { localForage } from '@mc/web-storage';
import { v4 as uuidV4 } from 'uuid';
import Cookies from 'js-cookie';

import { GaDataLayer } from '../public';

const IMPACT_COOKIE_NAME = 'notta_impact';

/** 获取校验后的impact信息 */
const getValidatedImpactInfo = async () => {
  const impactCookie = Cookies.get(IMPACT_COOKIE_NAME);

  if (!impactCookie) return false;

  const data = await localForage.getItem({ key: 'impactInfo' });

  if (!data) return false;
  if (!window['ire']) return false;

  const { expireTime } = data as any;
  if (!expireTime) return false;

  // 如果当前时间小于存储时间，则数据有效
  if (new Date().getTime() > Number(expireTime)) return false;

  return data;
};

export const impactIntegration = async (clickId: string) => {
  if (!window?.['ire']) return;

  const impactInfo = await getValidatedImpactInfo();

  // 如果impact信息已经存在并且有效，则使用存储的数据进行初始化，不进行数据更新
  if (impactInfo) {
    const { customerId, customerEmail, customProfileId } = impactInfo as any;

    window['ire']('identify', {
      customerId,
      customerEmail,
      customProfileId,
    });

    GaDataLayer({ event: 'IdentifyInvoked' });
  } else {
    if (!clickId) return;

    const customProfileId = uuidV4();
    const customerId = customProfileId;
    const expireTime = dayjs().add(12, 'month').valueOf();

    const impactIdentifyInfo = {
      customerId,
      customerEmail: '',
      customProfileId,
    };

    window['ire']('identify', impactIdentifyInfo);

    const impactInitInfo = {
      ...impactIdentifyInfo,
      expireTime,
      clickId,
    };

    localForage.setItem({
      key: `impactInfo`,
      value: impactInitInfo,
    });

    Cookies.set(IMPACT_COOKIE_NAME, aesEncode(JSON.stringify(impactInitInfo), TOKEN_SECRET), {
      domain: '.notta.ai',
      expires: 365,
    });

    GaDataLayer({ event: 'IdentifyInvoked' });
  }
};

/**
 * @name impact-Leads_Generation事件数据上报
 * @param email 联系邮箱
 */
export const impactLeadsGenerationReport = async (email: string) => {
  const impactInfo = await getValidatedImpactInfo();
  if (!impactInfo) return;

  const { customerId, customProfileId, clickId } = impactInfo as any;

  window['ire'](
    'trackConversion',
    44564, // 固定值 - impact 提供
    {
      orderId: 'Official_Website_Enterprise_Custom_Order',
      clickId,
      customProfileId,
      customerId,
      customerEmail: email ?? '',
      customerStatus: 'New',
      currencyCode: 'USD',
      orderPromoCode: '',
      items: [
        {
          subTotal: 0,
          category: 'Enterprise',
          sku: 'Enterprise',
          quantity: 1,
          name: 'Enterprise Custom',
        },
      ],
    },
    {
      verifySiteDefinitionMatch: true,
    },
  );
};
